<div class="accordion-card" data-testid="component-accordion-cart">
  <div class="title {{ background }}" [class.is-open]="!isHidden">
    <p class="title" (click)="clickTitle(collapse)">{{ title }}</p>

    <button *ngIf="!isHidden && !legacyInProgress && data?.legacy && !data?.fully_migrated" class="card legacy-button lead-leagcy-animation" ngbTooltip="Solicitar Dados Legados"
    (click)="onRequestLegacy()"
    >
      Solicitar Dados Legados
    </button>

    <p *ngIf="!isHidden && legacyInProgress && data?.legacy" class="title">
      O botão será liberado após a conclusão do processamento da outra lista.
    </p>


    <div class="title-icons">
      <a
        *ngFor="let icon of titleIcons"
        [ngbTooltip]="icon.tooltip"
        class="btn btn-icon btn-primary me-1 {{ icon.color }}"
        (click)="clickIcon(icon)"
        [attr.data-testid]="icon.dataTestId"
      >
        <i class="fa {{ icon.icon }}"></i>
        {{ icon.text }}
      </a>
    </div>

    <span
      *ngIf="toggle"
      (click)="clickTitle(collapse)"
    >
      <i class="fa fa-chevron-right"
        [class.is-open]="!isHidden"></i>
    </span>

  </div>
  <div class="body"
    #collapse="ngbCollapse"
    [(ngbCollapse)]="isHidden">
    <ng-content></ng-content>
  </div>
</div>
